"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointUpdatedEvent = void 0;
class EndpointUpdatedEvent {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointUpdatedEvent.attributeTypeMap;
    }
}
exports.EndpointUpdatedEvent = EndpointUpdatedEvent;
EndpointUpdatedEvent.discriminator = undefined;
EndpointUpdatedEvent.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "EndpointUpdatedEventData",
        "format": ""
    },
    {
        "name": "type",
        "baseName": "type",
        "type": "EndpointUpdatedEventTypeEnum",
        "format": ""
    }
];
//# sourceMappingURL=EndpointUpdatedEvent.js.map